import {
  InventoryCheckEventType,
  InventoryCheckType,
} from '../shared-entities';

export interface IInventoryCheckStockBase {
  id: string;
  scheduledDate: string;
  type: InventoryCheckType;
  comment?: string;
  requiresAuthorisation?: boolean;
  forceStockTake: boolean;
  preventSales?: boolean;
  blind?: boolean;
}

export interface IInventoryCheckDates {
  createdAt: string;
  updatedAt: string;
}

export interface IInventoryCheckStockCheckSaveResponse {
  inventoryCheckId: string;
  stockTakeProducts: IInventoryCheckProduct[];
}

export interface IInventoryCheckProduct {
  actualQuantity: number | null;
  expectedQuantity: number;
  cost?: number;
  productId: string;
  name?: string;
}

export interface IInventoryCheckItem {
  id: string;
  name: string;
  actualQuantity?: number;
  expectedQuantity: number;
  cost: number | null;
  sku: string | null;
  productCode: string | null;
  createdAt: Date;
  updatedAt: Date;


}

export interface IInventoryCheckStockTake extends IInventoryCheckStockBase {
  preferredUserId?: string;
  locationId: string;
}

export interface IInventoryCheckStockTakeBatch
  extends IInventoryCheckStockBase {
  locationData: IInventoryCheckLocationData[];
}

export interface IInventoryCheckLocationData {
  locationId: string;
  preferredUserId: string;
}

export interface IInventoryCheckUser {
  id: string;
  firstName: string;
  surname: string;
}

export interface IInventoryCheckStockTakeResponse
  extends IInventoryCheckUser,
    IInventoryCheckStockTake,
    IInventoryCheckDates {
  id: string;
  location: {
    id: string;
    name: string;
  };
  latestEvent: IInventoryCheckEventResponse;
  preferredUser: IInventoryCheckUser;
}

export interface IInventoryCheckEvent {
  createdAt?: string;
  id: string;
  type: InventoryCheckEventType;
}

export interface IInventoryCheckEventResponse extends IInventoryCheckEvent {
  user: IInventoryCheckUser;
}

export interface IInventoryEventUpdateResponse {
  event: IInventoryCheckEvent;
}

export interface IInventoryCheckStockTakeCreateResponse
  extends IInventoryCheckStockTake {
  id: string;
}

export interface IInventoryCheckStockTakeCreateBatchResponse {
  items: IInventoryCheckStockTakeCreateResponse[];
}

export interface IInventoryCheckProductData {
  productId: string;
  quantity: number;
  name?: string;
}

export interface IInventoryCheckStockTakeProducts {
  items: IInventoryCheckProductData[];
}

export interface IInventoryCheckStockTakeLocation {
  id: string;
  name: string;
}

export interface IInventoryCheckStockTakeDetails
  extends IInventoryCheckStockBase,
    IInventoryCheckDates {
  id: string;
  preferredUser: IInventoryCheckUser;
  user: IInventoryCheckUser;
  events: IInventoryCheckEventResponse[];
  latestEvent: IInventoryCheckEventResponse;
  location: IInventoryCheckStockTakeLocation;
  productsSummary: IInventoryCheckProductsSummary;
}

export interface IInventoryCheckStockTakeSearch {
  page?: number;
  pageSize?: number;
  queryString?: string;
}

export interface IInventoryCheckProductsSummary {
  totalOver: number;
  totalUnder: number;
  valueOver: number;
  valueUnder: number;
}
